import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Validators, FormGroup} from '@angular/forms';
import {FormlyFieldConfig} from 'ng-formly';
import { Urls } from '../urls';
import { PlaceholderFieldsService } from '../placeholder-fields.service';
import { Response } from '../response';

@Component({
  selector: 'app-new-service',
  templateUrl: './new-service.component.html',
  styleUrls: ['./new-service.component.css']
})
export class NewServiceComponent implements OnInit {

  constructor(private http: HttpClient,private urls : Urls, private pFields : PlaceholderFieldsService ) {
   
   }
   form = new FormGroup({});
   forms=[];
   fields = [];
   response ="";
   model = {};
  ngOnInit() : void {
    this.fields = this.pFields.get();
    this.get();
  }
  get() : void 
  {
    this.http.get<Response>(this.urls.forNewServiceFields()).subscribe(data =>{
      this.fields = data.data;
    });
  }
  set() : void 
  {
    var viewModel = {'viewModel' : this.model};
    this.http.post<Response>(this.urls.forNewServiceCall(),viewModel).subscribe(data=>{
       this.response = data.data;
    });
	}

}



// WEBPACK FOOTER //
// /Users/sachinmacbook/Sites/ngfront/src/app/new-service/new-service.component.ts